<template>
    <internal>
        <div class="p-6 bg-white border-b border-gray-200 overflow-y-scroll h-screen-80 shadow-sm sm:rounded-lg">
            <p class="text-lg font-medium mb-2">Regenerate ID Card Requests </p>

            <breeze-table
                :fields="[
                        {'key':'name','label':'Name'},
                        {'key':'type','label':'Type'},
                        {'key':'action','label':'action'},
                        ]"
                :items="items"

                :canCreate="hasRole('Create RegenerateIDCard')"
                :canView="hasRole('View RegenerateIDCard')">
                <template #name="data">
                    {{ data.item?.student?.first_name ?? data.item?.faculty?.first_name }}
                    {{ data.item?.student?.last_name ?? data.item?.faculty?.last_name }}
                </template>
                <template #type="data">
                        <span class="capitalize">{{data.item.type}}</span>
                </template>
                <template #action="data">
                    <button-link
                        v-if="hasRole('Edit RegenerateIDCard')"
                        class="ml-2"
                        @click="handleResetIdCard(data.item.id);">
                        Reset ID
                    </button-link>
                </template>

            </breeze-table>

        </div>
    </internal>
</template>

<script setup>
import Internal from '@/Pages/Internal/Internal'
import BreezeTable from '@/Components/Table'
import ButtonLink from '@/Components/ButtonLink'
import {defineProps, ref} from "vue";
import {useForm} from '@inertiajs/inertia-vue3';
import {hasRole} from "../../../../Utils/checkPermission";

const props = defineProps({
    regenerates: Object,
    branch: String,
})
const form = useForm([]);
const items = ref(props.regenerates);

function handleResetIdCard(item) {

    form.post(route('internal.regenerate.destroy', [props.branch, item]), {
        onSuccess: () => {
          window.location.reload();
        }
    });
}

// internal.collection.destroy
</script>
